import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AiModel } from "@/actions/ssr/settings/getAiModelsSSR";

export interface AiModelsState {
  aiModels: AiModel[];
  aiModelsLoading: boolean;
  activeModelId: string;
  activeModelUpdateLoading: boolean;
}

const initialState: AiModelsState = {
  aiModels: [],
  aiModelsLoading: false,
  activeModelId: "openai/gpt-4o-mini",
  activeModelUpdateLoading: false,
};

export const aiModelsSlice = createSlice({
  name: "aiModels",
  initialState,
  reducers: {
    setAiModels: (state, action: PayloadAction<AiModel[]>) => {
      state.aiModels = action.payload;
    },
    setAiModelsLoading: (state, action: PayloadAction<boolean>) => {
      state.aiModelsLoading = action.payload;
    },
    setActiveModelId: (state, action: PayloadAction<string>) => {
      state.activeModelId = action.payload;
    },
    setActiveModelUpdateLoading: (state, action: PayloadAction<boolean>) => {
      state.activeModelUpdateLoading = action.payload;
    },
  },
});

export const {
  setAiModels,
  setAiModelsLoading,
  setActiveModelId,
  setActiveModelUpdateLoading,
} = aiModelsSlice.actions;

export default aiModelsSlice.reducer;
